export const GET_TRANSACTION_INSTALLMENT_TYPE_DEF = "GET_TRANSACTION_INSTALLMENT_TYPE_DEF"
export const GET_TRANSACTION_INSTALLMENT_TYPE_DEF_SUCCESS = "GET_TRANSACTION_INSTALLMENT_TYPE_DEF_SUCCESS"
export const GET_TRANSACTION_INSTALLMENT_TYPE_DEF_FAIL = "GET_TRANSACTION_INSTALLMENT_TYPE_DEF_FAIL"

export const TRANSACTION_INSTALLMENT_TYPE_DEF_API_ERROR = "API_ERROR"